import { Box, Grid2, Typography } from "@mui/material";
import CustomIcon from "../../../../Components/CustomIcon";
import Cookies from "universal-cookie";
import moment from "moment";

const normalizeBoolean = (val) => {
    if (typeof val === 'boolean') return val;
    if (typeof val === 'number') return val === 1;
    if (typeof val === 'string') {
      const lower = val.trim().toLowerCase();
      return lower === 'true' || lower === '1';
    }
    return false; // default for anything else (null, undefined, etc.)
};

export default function DeviceHealthRow({label, value, type = null, unit = null}) {

    const cookies = new Cookies();
    const timeZone = cookies.get("timeZone");

    const renderValue = () => {

        if ([null, undefined, ''].includes(value)) {
            return <Typography variant="fw500s14c2E2E2E" sx={{lineHeight: '32px'}}>{'-'}</Typography>
        }

        if (type === 'boolean') {
            const boolVal = normalizeBoolean(value);
            return (
                <Box sx={{px: 1.5, backgroundColor: boolVal ? '#EEF4DB' : '#FFF1F1', borderRadius: 1}}>
                    <Typography variant="fw500s14c2E2E2E" sx={{lineHeight: '32px', textTransform: 'capitalize'}}>{boolVal ? 'true' : 'false'}</Typography>
                </Box>
            );
        }

        if (type === 'connection_status') {
            return (
                <Box sx={{display: 'flex', alignItems: 'center', columnGap: 1.25}}>
                    <Box sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: value?.toLowerCase() === 'connected' ? '#09B820' : '#8F8F8F',
                    }} />
                    <Typography variant="fw500s14c2E2E2E" sx={{lineHeight: '32px'}}>{value}</Typography>
                </Box>
            );
        }

        if (type === 'signal_strength') {
            let valueText = 'No Signal';
            if (value >= 5) {
                valueText = 'Strong';
            } else if (value >= 3) {
                valueText = 'Moderate';
            } else if (value >= 1) {
                valueText = 'Low';
            }
            return (
                <Box sx={{display: 'flex', alignItems: 'center', columnGap: 1.25}}>
                    <CustomIcon name={'network-strength-icon'} strength={value} />
                    <Typography variant="fw500s14c2E2E2E" sx={{lineHeight: '32px'}}>{valueText}</Typography>
                </Box>
            );
        }

        if (type === 'datetime') {
            const formattedDatetime = moment?.utc(value, "YYYY-MM-DD HH:mm:ss")?.tz(timeZone)?.format("D MMMM YYYY HH:mm:ss");
            return (
                <Typography variant="fw500s14c2E2E2E" sx={{lineHeight: '32px'}}>{formattedDatetime}</Typography>
            );
        }

        return (
            <Typography variant="fw500s14c2E2E2E" sx={{lineHeight: '32px'}}>{value}{unit ? ` ${unit}` : ''}</Typography>
        );
    }

    return (
        <Grid2 container justifyContent={'space-between'} alignItems={'center'} width={399} pb={0.5} sx={{borderBottom: '1px solid #E9E9E9'}}>
            <Typography variant="fw400s14c686868" sx={{lineHeight: '24px', textTransform: 'capitalize'}}>{label.trim()}:</Typography>
            {renderValue()}
        </Grid2>
    )
}
